import { useEffect, useState } from 'react';
import type { JSX, ReactNode } from 'react';

/** Durée du bandeau, valeur verrouillée : docs/design/desktop-reference.md. */
const VISIBLE_MS = 2600;

/**
 * Le bandeau qui nomme la seule sortie possible du plein écran. Il apparaît quand on y entre et
 * s'efface après 2 600 ms — le temps de le lire, pas plus.
 *
 * Il n'est monté **que** pendant le plein écran (c'est l'appelant qui décide) : hors de là, il
 * n'existe pas dans le DOM. C'est ce qui permet de n'avoir aucun `setState` synchrone dans un
 * effet — l'entrée est une animation CSS, la sortie un simple `setTimeout`.
 */
export function FullscreenHint({ children }: { children: ReactNode }): JSX.Element {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const id = setTimeout(() => {
      setVisible(false);
    }, VISIBLE_MS);
    return () => {
      clearTimeout(id);
    };
  }, []);

  return (
    <div className={visible ? 'hint show' : 'hint'} role="status">
      {children}
    </div>
  );
}
